import React, { Suspense } from 'react';
import { FullscreenView } from '@cp/ds/src/components/modalView/view.fullscreen';
import { ModalContainer, ModalLayout } from '@cp/ds/src/components/modalLayout';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { IModalWrapperProps } from './modal.interface';

export const FullscreenModal: React.FC<IModalWrapperProps> = ({ open, contentProps, ContentComponent, onClose, onClosed }) => (
  <FullscreenView isOpen={open} onClose={onClose} onClosed={onClosed}>
    <Suspense
      fallback={
        <ModalLayout>
          <ModalContainer>
            <ContentSkeleton blocks={4} />
          </ModalContainer>
        </ModalLayout>
      }
    >
      <ContentComponent {...contentProps} />
    </Suspense>
  </FullscreenView>
);
